export default "__VITE_ASSET__466db45c__"